var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 8.69519C17 8.11738 16.9522 7.53645 16.8502 6.96802H8.67041V10.2412H13.3546C13.1602 11.2969 12.5356 12.2307 11.6211 12.8242V14.948H14.4157C16.0567 13.4676 17 11.2813 17 8.69519Z",
    fill: "#3A84F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67048 17.0001C11.0094 17.0001 12.9818 16.2474 14.4189 14.9481L11.6244 12.8243C10.8469 13.3428 9.84311 13.6363 8.67366 13.6363C6.41125 13.6363 4.49297 12.1403 3.80468 10.1289H0.920898V12.3183C2.39306 15.1886 5.39156 17.0001 8.67048 17.0001V17.0001Z",
    fill: "#4BA756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.80163 10.1287C3.43837 9.07302 3.43837 7.9299 3.80163 6.87423V4.68481H0.921028C-0.308962 7.08661 -0.308962 9.9163 0.921028 12.3181L3.80163 10.1287V10.1287Z",
    fill: "#F5C041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74958 3.36434C9.98594 3.3456 11.1809 3.8016 12.0763 4.63864L14.5522 2.21185C12.9844 0.768899 10.9037 -0.0244134 8.74958 0.000572805C5.47067 0.000572805 2.47217 1.81207 1 4.68549L3.8806 6.87491C4.5657 4.86039 6.48716 3.36434 8.74958 3.36434V3.36434Z",
    fill: "#EB523E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/google.icon.f6865c4acd31bdd6670671e2f8a3ae22.svg";
export { ForwardRef as ReactComponent };